

































import Vue from 'vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import pxCard from '@/dex-shared/components/px-card.vue';

export default Vue.extend({
  components: {
    Content,
    pxCard,
    CheckIcon,
  },

  props: {
    interactiveData: {
      type: Object,
      required: true,
    },
    questionId: {
      type: Number,
      required: true,
    },
    questionAnswer: {
      type: Number,
      required: true,
    },
    stats: {
      type: Array as Vue.PropType<Object>,
      required: true,
    },
  },

  computed: {
    totalAnswers() {
      return this.stats.reduce((prev: number, cur: any) => prev + cur.total, 0);
    },
  },

  methods: {
    statByIndex(index: any) {
      let alternativeStat = this.stats.find(
        stat => parseInt(stat.answer) == index,
      );
      if (alternativeStat) {
        return Math.round((100 * alternativeStat.total) / this.totalAnswers);
      } else {
        return 0;
      }
    },
  },
});
